var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import FocusTrap from 'focus-trap-react';
import React from 'react';
import ReactDOM from 'react-dom';
import { ModalWrapper } from './variants/modal.variant.shared';
/**
 *
 * This component requires that a modal div be added to the public index.html file
 * directly above the root div in your app
 * It should look similar to the following:
 *
 * <div id="modal"></div>
 * <div id="root"></div>
 *
 * */
function ModalFocusTrap(_a) {
    var children = _a.children, focusTrap = _a.focusTrap;
    return focusTrap ? (React.createElement(FocusTrap, { focusTrapOptions: {
            fallbackFocus: '.sa-modal-background',
        } }, children)) : (React.createElement(React.Fragment, null, children));
}
function JSXModal(_a) {
    var children = _a.children, zIndex = _a.zIndex, onClickHandler = _a.onClickHandler, ariaLabel = _a.ariaLabel, className = _a.className, focusTrap = _a.focusTrap, rest = __rest(_a, ["children", "zIndex", "onClickHandler", "ariaLabel", "className", "focusTrap"]);
    return (React.createElement(ModalFocusTrap, { focusTrap: focusTrap },
        React.createElement(ModalWrapper, __assign({ "aria-label": ariaLabel, "aria-modal": "true", role: "dialog", onClick: function (event) { return onClickHandler(event); }, zIndex: zIndex, className: "sa-modal-background modal-wrapper " + (className || ''), tabIndex: "-1" }, rest), children)));
}
export var SAModal = function (_a) {
    var children = _a.children, zIndex = _a.zIndex, onClickHandler = _a.onClickHandler, ariaLabel = _a.ariaLabel, focusTrap = _a.focusTrap, rest = __rest(_a, ["children", "zIndex", "onClickHandler", "ariaLabel", "focusTrap"]);
    return ReactDOM.createPortal(React.createElement(JSXModal, __assign({ zIndex: zIndex, onClickHandler: onClickHandler, ariaLabel: ariaLabel, focusTrap: focusTrap }, rest), children), document === null || document === void 0 ? void 0 : document.querySelector('#modal'));
};
ModalFocusTrap.defaultProps = {
    focusTrap: false,
};
JSXModal.defaultProps = {
    focusTrap: false,
    zIndex: 1,
    ariaLabel: '',
    className: undefined,
};
SAModal.defaultProps = {
    focusTrap: false,
    zIndex: 1,
    ariaLabel: '',
    className: undefined,
};
//# sourceMappingURL=modal.component.js.map